import { render, staticRenderFns } from "./platformInfo.vue?vue&type=template&id=1e538090&scoped=true&"
import script from "./platformInfo.vue?vue&type=script&lang=js&"
export * from "./platformInfo.vue?vue&type=script&lang=js&"
import style0 from "./platformInfo.vue?vue&type=style&index=0&id=1e538090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e538090",
  null
  
)

export default component.exports